export default {
  name: 'marking--updHDocumentImport',
  apiService: 'shoes',
  apiPath: '/admin/upd_h/upload',
  urlParamName: 'marking--updHDocumentImport',
};
